module.exports = __webpack_public_path__ + "static/media/PushtimargImage18.9c56ec85.jpg";